import { adminState, adminGet, adminDelete, adminPost, adminPut } from './useAdminCore';
// ==================== Questionnaires ====================
function getQuestionnaires(onSuccess = null) {
    adminState.questionsLoading = true;
    adminState.questionsError = null;
    adminGet('/Questionnaires', (result) => {
        adminState.questionnaires = result;
        adminState.questionsLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createQuestionnaire(questionnaire, onSuccess = null) {
    adminPost('/Questionnaires', questionnaire, (data) => {
        getQuestionnaires();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.questionsError = 'Failed to create questionnaire';
    });
}
function updateQuestionnaire(id, questionnaire, onSuccess = null) {
    adminPut('/Questionnaires/' + id, questionnaire, (data) => {
        getQuestionnaires();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.questionsError = 'Failed to update questionnaire';
    });
}
function deleteQuestionnaire(id, onSuccess = null) {
    adminDelete('/Questionnaires/' + id, (data) => {
        getQuestionnaires();
        if (onSuccess)
            onSuccess(data);
    });
}
// ==================== Questions ====================
function getQuestions(onSuccess = null) {
    adminState.questionsLoading = true;
    adminState.questionsError = null;
    adminGet('/Questions', (result) => {
        adminState.questions = result;
        adminState.questionsLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createQuestion(question, onSuccess = null, onError = null) {
    adminPost('/Questions', question, (data) => {
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        adminState.questionsError = 'Failed to create question';
        if (onError)
            onError(error);
    });
}
function updateQuestion(id, question, onSuccess = null, onError = null) {
    adminPut('/Questions/' + id, question, (data) => {
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        adminState.questionsError = 'Failed to update question';
        if (onError)
            onError(error);
    });
}
function deleteQuestion(id, onSuccess = null) {
    adminDelete('/Questions/' + id, (data) => {
        if (onSuccess)
            onSuccess(data);
    });
}
// ==================== Questionnaire <-> Question links ====================
function addQuestionToQuestionnaire(questionnaireId, questionId, onSuccess = null, onError = null) {
    adminPost('/Questionnaires/' + questionnaireId + '/QuestionnaireQuestions/' + questionId, null, (data) => {
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        adminState.questionsError = 'Failed to add question to questionnaire';
        if (onError)
            onError(error);
    });
}
function removeQuestionFromQuestionnaire(questionnaireId, questionId, onSuccess = null) {
    adminDelete('/Questionnaires/' + questionnaireId + '/QuestionnaireQuestions/' + questionId, (data) => {
        if (onSuccess)
            onSuccess(data);
    });
}
export { getQuestionnaires, createQuestionnaire, updateQuestionnaire, deleteQuestionnaire, getQuestions, createQuestion, updateQuestion, deleteQuestion, addQuestionToQuestionnaire, removeQuestionFromQuestionnaire, };
